<template>
  <Layout style="overflow: auto; height: 100%" class="master">
    <Header class="header-con">
      <div class="header-bar">
        <div class="float-left">
          <Icon @click="toggleMobileMenu" :style="{ margin: '0 4px' }" class="hidden-lg-up" type="md-menu" size="24" />
        </div>

        <div class="logo">
          <img src="../../images/logo-banner.png" />
        </div>

        <div class="custom-content-user float-right">
          <user :message-unread-count="unreadCount" :user-avatar="userAvatar" />
          <notice style="margin-right: 8px; cursor: pointer"></notice>
          <fullscreen v-model="isFullscreen" class="hidden-lg-down" style="margin-right: 4px" />
        </div>
      </div>
    </Header>
    <Layout class="main-content">
      <Sider ref="leftSider" :width="78" class="left-sider hidden-lg-down" hide-trigger>
        <Menu :active-name="activeMenuName" @on-select="handleMenuSelect" :class="menuitemClasses" width="auto" style="height: calc(100% - 100px)">
          <MenuItem :to="{ name: 'freeTrialConsole' }" name="freeTrialConsole">
            <div class="menu-icon menu-icon-free-trial" />
            <p>Free Trials</p>
          </MenuItem>
          <MenuItem :to="{ name: 'churn' }" name="churn">
            <div class="menu-icon menu-icon-churn" />
            <p>Churn</p>
          </MenuItem>
        </Menu>
      </Sider>
      <Content>
        <Drawer :closable="false" v-model="showMobileMenu" class="mobile-menu" placement="left" width="200px">
          <Menu :active-name="activeMenuName" @on-select="handleMenuSelect" class="menu-item" width="auto">
            <MenuItem :to="{ name: 'freeTrialConsole' }" name="freeTrialConsole">
              <div class="menu-icon menu-icon-free-trial" />
              <span>Free Trials</span>
            </MenuItem>
            <MenuItem :to="{ name: 'churn' }" name="churn">
              <div class="menu-icon menu-icon-churn" />
              <span>Churn</span>
            </MenuItem>
          </Menu>
        </Drawer>

        <keep-alive :include="cacheList">
          <router-view> </router-view>
        </keep-alive>
        <ABackTop :height="100" :bottom="80" :right="50" container=".main-content"></ABackTop>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import User from "./components/user";
import Notice from "../notices/notice.vue";
import ABackTop from "./components/a-back-top";
import Fullscreen from "./components/fullscreen";
import ErrorStore from "./components/error-store";
import { mapState, mapGetters } from "vuex";

import { on } from "iview/src/utils/dom";
import { dimensionMap } from "iview/src/utils/assist";

import moment from "moment";
import "./master.less";

export default {
  name: "Master",
  components: {
    Fullscreen,
    ErrorStore,
    User,
    Notice,
    ABackTop,
  },
  data() {
    return {
      isCollapsed: false,
      hoverCollapseToggled: false,
      collapsed: false,
      isFullscreen: false,
      showMobileMenu: false,
      showPastDueWarning: false,
      showPlanSelector: false,
      mediaMatched: false,
      activeMenuName: "dashboard",
      accountId: window.abp && window.abp.custom.currentBillingAccountId ? window.abp.custom.currentBillingAccountId : 0,
    };
  },
  computed: {
    ...mapState("session", ["billingAccounts", "user"]),
    ...mapState("billing", ["billingAccount"]),
    userAvatar() {
      return this.$store.state.user.avatarImgPath;
    },
    cacheList() {
      return this.$store.state.app.cachePage;
    },
    local() {
      return this.$store.state.app.local;
    },
    hasReadErrorPage() {
      return this.$store.state.app.hasReadErrorPage;
    },
    unreadCount() {
      return this.$store.state.user.unreadCount;
    },
    rotateIcon() {
      return ["menu-toggler-icon", this.isCollapsed ? "rotate-icon" : ""];
    },
    menuitemClasses: function () {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
  },
  watch: {
    $route(newRoute) {
      this.setActiveMenuName(newRoute);
    },
  },
  mounted() {
    console.info("master mounted");

    this.setActiveMenuName(this.$route);

    on(window, "resize", this.onWindowResize);
    this.matchMedia();
  },
  beforeDestroy() {},
  methods: {
    initSessionInfo() {
      this.$store
        .dispatch("billing/getBillingAccountInfo")
        .then((response) => {})
        .finally(() => {});

      this.$store
        .dispatch("session/init")
        .then((response) => {})
        .finally(() => {});
    },
    handleNotificationReceived(userNotification) {
      console.log(userNotification);
      if (userNotification.notification.entityId === this.billingAccount.id && userNotification.notification.data.version >= 0) {
        this.initSessionInfo();
      }
    },
    handleMenuSelect() {
      //this.$store.dispatch("goal/setActiveMenu", menuId);
    },
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    matchMedia() {
      let matchMedia;
      if (window.matchMedia) {
        matchMedia = window.matchMedia;
      }
      let mediaMatched = this.mediaMatched;
      this.mediaMatched = matchMedia(`(max-width: ${dimensionMap["xl"]})`).matches;

      if (this.mediaMatched !== mediaMatched) {
        if (this.mediaMatched !== this.isCollapsed) {
          //this.$refs.leftSider.toggleCollapse();
        }
      }
    },
    onWindowResize() {
      this.matchMedia();
    },
    setActiveMenuName(route) {
      if (route.name === "goal") {
        this.activeMenuName = "goals";
      } else if (route.name === "project") {
        this.activeMenuName = "projects";
      } else if (route.name === "user") {
        this.activeMenuName = "users";
      } else {
        this.activeMenuName = route.name;
      }
    },
  },
};
</script>

<style scoped>
.rotate-icon {
  transform: rotate(-90deg);
}

.left-sider-top {
  height: 45px;
  text-align: center;
  padding: 4px;
}
</style>